<template>
    <el-dialog
        title="Live stream"
        :visible="visible"
        @update:visible="$emit('update:visible', $event)"
      >
        <el-form ref="streamRequest" :model="streamRequest" :rules="rules">
          <el-row :gutter="20">
            <el-col :md="24" :lg="12">
              <el-form-item label="Channels" label-width="120px" prop="channels">
                <el-select
                  v-model="streamRequest.channels"
                  multiple
                  placeholder="Please select channels"
                >
                  <el-option
                    v-for="item in channels"
                    :key="item.id"
                    :label="item.name"
                    :value="item.channelIndex"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="streamRequest.error">Error: {{streamRequest.error}}</el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="startStream">Confirm</el-button>
        </span>
      </el-dialog>
</template>

<script>
export default {
    props: ['device', 'visible'],
    data() {
      return {
        rules: {
          channels: [
            {
              type: "array",
              required: true,
              message: "Please select channels",
              trigger: "blur"
            }
          ]
        },
        streamRequest: {
          channels: []
        }
      }
    },
    computed: {
        channels() {
          return (this.device || {channels: []}).channels;
        }
    },
    watch: {
        device() {
            this.streamRequest.channels = [];
        }
    },
    methods: {
      startStream() {
        this.$refs.streamRequest.validate(valid => {
          if (!valid) return;
          const { channels } = this.streamRequest;
          this.$router.push({
            name: "streamDevice",
            params: { serial: this.device.serial },
            query: { channels }
          });
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// LiveStreamDialog.vue?5158685b